import { gql } from '@apollo/client';

export const GET_BLOCK_FULL_SESSION_AVAILABILITY = gql`
  query GetBlockFullSessionAvailability {
    vm {
      configItem(key: "block-full-session-availability") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;
